import { type TypePolicies } from "@apollo/client"

export const dataSource: TypePolicies = {
  DataSourcePreference: {
    keyFields: ["dataSourceId"],
  },
}
